<app-page-content [showProgress]="deleting || saving">
  <span pagetitle *ngIf="session.userMaintenanceIsAllowed()">{{ isNewUser() ? 'Ny bruker' : 'Rediger bruker' }}</span>
  <span pagetitle *ngIf="!session.userMaintenanceIsAllowed()">Bruker</span>

  <form pagecontent [formGroup]="userForm" style="padding: 0.5em; display: flex; flex-direction: column">
    <mat-form-field style="width: 100%" floatLabel="always">
      <mat-label>Navn</mat-label>
      <input matInput formControlName="Name" required>
    </mat-form-field>
    <mat-form-field style="width: 100%" floatLabel="always">
      <mat-label>Brukernavn</mat-label>
      <input matInput formControlName="UN" placeholder="Brukernavn" autocomplete="new-password" required>
    </mat-form-field>
    <mat-form-field style="width: 100%" floatLabel="always">
      <mat-label>Passord</mat-label>
      <input matInput formControlName="Pwd" type="password" autocomplete="new-password" required="{{isNewUser()}}">
    </mat-form-field>
    <mat-form-field style="width: 30%">
      <mat-label>Brukertype</mat-label>
      <mat-select [disabled]="!isNotCurrentUser()" formControlName="Type" required>
        <mat-option value="WebAdmin">Administrator</mat-option>
        <mat-option value="Driver">Sjåfør</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="hasRoutes()" style="width: 30%" floatLabel="always">
      <mat-label>Bærere</mat-label>
      <mat-select formControlName="Carriers" multiple>
        <mat-option *ngFor="let carrier of carriers" [value]="carrier.Id">{{ carrier.Name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle [disabled]="!isNotCurrentUser()" formControlName="Active" required>Aktiv</mat-slide-toggle>
  </form>

  <app-button-box pagefooter>
    <button color="warn" (click)="cancel()" mat-raised-button *ngIf="session.userMaintenanceIsAllowed()">AVBRYT</button>
    <button color="primary" (click)="save()" mat-raised-button *ngIf="session.userMaintenanceIsAllowed()">LAGRE</button>
    <button color="primary" (click)="close()" mat-raised-button *ngIf="!session.userMaintenanceIsAllowed()">LUKK</button>
  </app-button-box>

  <app-button-box pageheaderactions>
    <button *ngIf="!isNewUser() && isNotCurrentUser() && session.userMaintenanceIsAllowed()" color="warn" (click)="deleteUser()" mat-raised-button>SLETT</button>
  </app-button-box>
</app-page-content>
